import React from 'react';
import { Select } from 'antd';
import { formConfig, modes } from '../../../../config';
import { pathSegments, useWorkers } from '../../../../api/queries/useWorkers';
import { dspxGetWorkerChildrens } from '../../../../../../../../helpers/dspx-utils';
import FormItem from '../FormItem/FormItem';
import { getInitValForWorkersField } from '../../utils';

const isWarrantyParams = {
  [modes.regularToPossWarranty]: true,
  [modes.possWarrantyToRegular]: false,
  [modes.warrantyToRegular]: false,
};

const { fieldNames } = formConfig;

const SelectExecuterField = ({ form, request, mode }) => {
  const { houseId, serviceId, executer } = request;

  const { data, isFetching } = useWorkers(
    {
      pathSegment: pathSegments.executers,
      houseId,
      serviceId,
      isWarranty: isWarrantyParams[mode],
    },
    { staleTime: Infinity, enabled: Boolean(request) }
  );

  const initialValue = data?.length
    ? getInitValForWorkersField({ entities: data, entity: executer })
    : undefined;

  return (
    <FormItem label="Исполнитель">
      {form.getFieldDecorator(fieldNames.executer, {
        initialValue,
      })(
        <Select
          showSearch
          allowClear
          placeholder="Выберите исполнителя"
          optionFilterProp="searchtext"
          loading={isFetching}
          optionLabelProp="label"
        >
          {dspxGetWorkerChildrens(data, undefined, true)}
        </Select>
      )}
    </FormItem>
  );
};

export default SelectExecuterField;
